<template>
  <div v-if="visible" class="plus-wf-anchor-layer">
    <div class="plus-wf-anchor-layer__backdrop" @click="$emit('close')"></div>
    <div class="plus-wf-anchor-layer__panel" :style="panelPositionStyle" @click.stop>
      <div class="px-6 pt-5 pb-4 flex items-start justify-between">
        <div>
          <div class="text-[14px] font-black text-gray-100 tracking-tight">我的资产</div>
          <div class="mt-2 flex items-center gap-2 text-[10px]">
            <button
              type="button"
              class="px-2.5 py-1 rounded-lg border transition-colors"
              :class="
                assetTab === 'image'
                  ? 'bg-white/[0.10] border-white/[0.10] text-gray-100'
                  : 'border-transparent text-gray-500 hover:text-gray-300'
              "
              @click="assetTab = 'image'"
            >
              角色
            </button>
            <button
              type="button"
              class="px-2.5 py-1 rounded-lg border transition-colors"
              :class="
                assetTab === 'scene'
                  ? 'bg-white/[0.10] border-white/[0.10] text-gray-100'
                  : 'border-transparent text-gray-500 hover:text-gray-300'
              "
              @click="assetTab = 'scene'"
            >
              场景
            </button>
          </div>
        </div>
        <button
          type="button"
          class="w-9 h-9 rounded-full bg-black/30 border border-white/10 text-white/70 hover:text-white flex items-center justify-center"
          @click="$emit('close')"
        >
          <i class="fas fa-times text-[12px]"></i>
        </button>
      </div>

      <div class="px-6 pb-6 flex-1 min-h-0 overflow-y-auto">
        <div v-if="assetLoading" class="py-10 text-center text-gray-500 text-sm">加载中…</div>
        <div v-else-if="assetError" class="py-6 text-amber-200/90 text-sm">{{ assetError }}</div>
        <div v-else class="grid grid-cols-4 sm:grid-cols-6 gap-4">
          <button
            type="button"
            class="rounded-2xl overflow-hidden bg-black/25 border border-white/10 hover:border-fuchsia-500/30 aspect-[4/5] flex flex-col items-center justify-center"
            @click="$router.push('/assets')"
          >
            <div class="w-11 h-11 rounded-2xl border border-white/10 flex items-center justify-center">
              <i class="fas fa-plus"></i>
            </div>
            <div class="mt-2 text-[10px] text-gray-500 font-semibold">创建</div>
          </button>
          <button
            v-for="a in filteredAssetRows"
            :key="a.id"
            type="button"
            class="rounded-2xl overflow-hidden bg-black/10 border border-white/10 hover:border-white/20 aspect-[4/5]"
            :title="a.title"
            @click="$emit('pick-asset', a)"
          >
            <img :src="a.url" alt="" loading="lazy" class="h-full w-full object-cover" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workflowAnchoredModalMixin from '@/mixins/workflowAnchoredModalMixin'
import { fetchAssetLibraryList } from '@/utils/assetLibraryApi'

export default {
  name: 'WorkflowAssetPanelModal',
  mixins: [workflowAnchoredModalMixin],
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      assetTab: 'image',
      assetLoading: false,
      assetError: '',
      assetRows: []
    }
  },
  computed: {
    filteredAssetRows() {
      const tab = this.assetTab === 'scene' ? 'scene' : 'image'
      return (this.assetRows || []).filter((r) => (r.kind || 'image') === tab)
    },
    panelPositionStyle() {
      return this.buildPanelPositionStyle()
    }
  },
  watch: {
    visible(v) {
      if (v) this.loadAssets()
    }
  },
  methods: {
    getPanelLayoutOptions() {
      return { panelWidth: 560, panelMaxHeight: 420, gap: 10, align: 'right' }
    },
    async loadAssets() {
      this.assetLoading = true
      this.assetError = ''
      try {
        const rows = await fetchAssetLibraryList({ limit: 200 })
        this.assetRows = (rows || [])
          .map((x) => ({
            id: x.id != null ? String(x.id) : '',
            kind: x.kind || 'image',
            url: x.url || '',
            title: x.title || '未命名'
          }))
          .filter((r) => r.url)
      } catch (e) {
        this.assetRows = []
        this.assetError = (e && e.message) || '加载资产失败'
      } finally {
        this.assetLoading = false
      }
    }
  }
}
</script>

<style scoped>
.plus-wf-anchor-layer {
  position: fixed;
  inset: 0;
  z-index: 5000;
  pointer-events: none;
}
.plus-wf-anchor-layer__backdrop {
  position: fixed;
  inset: 0;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.12);
}
.plus-wf-anchor-layer__panel {
  position: fixed;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  overflow: hidden;
  border-radius: 24px;
  background: rgba(26, 26, 31, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.65);
}
</style>
